import { Route } from 'vue-router';
import { useMBLStore } from '@/store/modules/master-bl/useMBLStore';
import { MBL_VIEW_TABS } from '@/constants/master-bl';

export const getMblViewBreadCrumbs = (route: Route) => {
  const query = route.query.tab as string;
  const mblStore = useMBLStore();
  const getLabel = (tab: string) => {
    switch (tab) {
      case MBL_VIEW_TABS.hblList:
        return 'HBL list view';
      case MBL_VIEW_TABS.charges:
        return 'Charges';
      case MBL_VIEW_TABS.attachments:
        return 'Attachments';
      case MBL_VIEW_TABS.pttApplication:
        return 'PTT Application';
      case MBL_VIEW_TABS.milestones:
        return 'Milestones';
      default:
        return '';
    }
  };

  const resultBreadcrumbs: any[] = [
    { text: `MBL list view`, to: { name: 'ManifestImports' } },
    {
      text: `MBL ${mblStore.mbl?.shipmentNumber ?? ''}`,
      to: { name: 'MasterBL', query: { tab: MBL_VIEW_TABS.mblDetails } },
    },
  ];
  if (query !== MBL_VIEW_TABS.mblDetails && query) {
    resultBreadcrumbs.push({ text: getLabel(query) });
  }

  return resultBreadcrumbs;
};
